// extracted by mini-css-extract-plugin
export default {"ScreenXSMax":"(max-width: 767px)","HeightSMMax":"(max-height: 639px)","ScreenSMMin":"(min-width: 768px)","imgSize":"250px","image":"G595647"};